import StyledWrapper from '@insite/client-framework/Common/StyledWrapper';
import { BaseTheme } from '@insite/mobius/globals/baseTheme';
import Typography from '@insite/mobius/Typography';
import { breakpointMediaQueries } from '@insite/mobius/utilities';
import getColor from '@insite/mobius/utilities/getColor';
import InjectableCss from '@insite/mobius/utilities/InjectableCss';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';

interface SwitchProps {
  isToggled: boolean;
}

export interface ActiveItemsToggle {
    ToggleContainer?: InjectableCss;
}

export const ActiveItemsStyle: ActiveItemsToggle = {
    ToggleContainer: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding: 0px 5px;
            width: 110px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        background: #ffffff;
                        border: 1px solid #ccc;
                        border-right: none;
                    `,
                    css`
                        background: #ffffff;
                        border: 1px solid #ccc;
                        border-right: none;
                    `,
                    css`
                        background: #ffffff;
                        border: 1px solid #ccc;
                        border-right: none;
                    `,
                    css`
                        
                    `,
                    css`
                        
                    `,
        ])}
        `,
    }
   
};


const Switch = styled.div<SwitchProps>`
  width: 53px;
  height: 25px;
  background-color: ${(props) => (props.isToggled ? getColor("primary.main") : getColor("common.border"))};
  border-radius: 15px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const Circle = styled.div<SwitchProps>`
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: ${(props) => (props.isToggled ? '30px' : '2px')};
  transition: left 0.3s ease;
`;

const styles = ActiveItemsStyle;

interface ActiveItemsToggleProps {
  isActiveToggleHandler: (value: boolean) => void;
  isActiveToggle: boolean;
}

export const ActiveItemsToggle: React.FC<ActiveItemsToggleProps> = ({ isActiveToggleHandler, isActiveToggle }) => {

  const [isToggled, setIsToggled] = useState(isActiveToggle); // Use prop value as initial state

  const handleToggle = () => {
    const newValue = !isToggled; // Toggle the state
    setIsToggled(newValue);
    isActiveToggleHandler(newValue); // Pass new value to parent component
  };

  return (
    <StyledWrapper  {...styles.ToggleContainer}>
        <Typography style={{lineHeight:"19px"}}>{isToggled ? "Active Items":"All Items"}</Typography>
        <Switch isToggled={isToggled} onClick={handleToggle}>
            <Circle isToggled={isToggled} />
        </Switch>
    </StyledWrapper>
  );
};

